import React, { useState, useEffect, useContext, useMemo } from 'react';
import { Row, Col, Button, /*Tab,*/ Form /* Nav , OverlayTrigger, Tooltip, Spinner */ } from 'react-bootstrap';
import { IcoPlus, IcoMinusCircled } from '@icons';
import {
	editProject,
	getAllProjectTarget,
	createProjectTarget,
	editProjectTarget,
	deleteProjectTarget,
	editApplicationEconomicFrameworkValue,
	getAllProjectInternalExpenseItems,
	// createProjectInternalExpenseItems,
	// editProjectInternalExpenseItems,
	// deleteProjectInternalExpenseItems,
	getProjectStats,
	downloadEconomicFramework,
} from '@lib/api';
import { InputNumber } from 'primereact';
import StatusBar from '@components/StatusBar';
import moment from 'moment';
import { dateFormatter, dateFormatterInput, formatToDecimals } from '@lib/helpers/formatting';
import { UserContext } from 'components/contexts/UserProvider';
import { translate } from 'components/translation/translation';
import { OETrans } from 'components/translation/OETrans';
import EconomicFrameworkWp from 'components/candidacy/EconomicFrameworkWp';
import EconomicFrameworkStream from 'components/candidacy/EconomicFrameworkStream';
import DownloadExcelButton from '@components/form/DownloadExcelButton';
import NavTabs from '@components/atomic/molecules/NavTabs/NavTabs';

const Candidacy = ({ project, summaryWheelsValues, fetchDataProject }) => {
	const {
		isOe,
		userAccess,
		isBeneficiary,
		myUser: { companies },
	} = useContext(UserContext);
	const [targets, setTargets] = useState([]);
	const [internalExpenseItems, setInternalExpenseItems] = useState([]);
	const [originTargets, setOriginTargets] = useState([]);
	const [applicationEconomicFrameworkValues, setApplicationEconomicFrameworkValues] = useState([]);
	// const [originInternalExpenseItems, setOriginInternalExpenseItems] = useState([]);
	const [projectAmounts, setProjectAmounts] = useState({
		totalAdmissibleAmount: 0,
		totalApprovedAmount: 0,
	});
	const [totalAmounts, setTotalAmounts] = useState({});
	const [totalControls, setTotalControls] = useState({});
	const [sbShow, setSbShow] = useState(<></>);
	const [rows, setRows] = useState([]);
	const [, /* economicsInternalRows */ setEconomicsInternalRows] = useState([]);
	const localLang = `${localStorage.getItem('userLanguage').toLowerCase()}-${localStorage.getItem('userLanguage')}`;
	const isProjectWp = useMemo(() => project?.streamConfigurationType === 'WP', [project?.streamConfigurationType]);

	const handleStatusBar = (status, message, timeout) => {
		setSbShow(<StatusBar status={status} message={message} timeout={timeout} />);
	};

	const [isModified, setIsModified] = useState(false);

	useEffect(() => {
		if (project.id) {
			let tempApplicationEconomicFrameworkValues = [...project.applicationEconomicFrameworkValues];

			tempApplicationEconomicFrameworkValues = tempApplicationEconomicFrameworkValues.map((el) => ({
				...el,
				requiredAmount: (el.approvedAmount * el.intensity) / 100,
			}));

			setApplicationEconomicFrameworkValues(tempApplicationEconomicFrameworkValues);

			getAllProjectInternalExpenseItems(project.id).then((internalExpenseItems) => {
				setInternalExpenseItems(internalExpenseItems.data);
				// setOriginInternalExpenseItems(internalExpenseItems.data);
			});

			getAllProjectTarget(project.id).then((targets) => {
				const tempTargets = targets.data.map((target) => ({
					id: target.id,
					name: target.name,
					description: target.description,
					uom: target.uom,
					projectId: target.projectId,
					noticeTargetId: target.noticeTargetId,
					targetValue: target.targetValue,
					targetDate: target.targetDate,
				}));

				setTargets(tempTargets);
				setOriginTargets(tempTargets);
			});

			setProjectAmounts({
				totalAdmissibleAmount: project.totalAdmissibleAmount ?? 0,
				totalApprovedAmount: project.totalApprovedAmount ?? 0,
			});
		}
	}, [project]);

	useEffect(() => {
		if (summaryWheelsValues.length > 0) {
			setTotalControls({
				totalAmount: summaryWheelsValues
					.filter((el) => el.propertyName === 'totalAmount')
					.map((el) => el.propertyValue ?? 0)
					.pop(),
				totalApprovedAmount: summaryWheelsValues
					.filter((el) => el.propertyName === 'totalApprovedAmount')
					.map((el) => el.propertyValue ?? 0)
					.pop(),
			});
		} else if (summaryWheelsValues.length === 0 && project.id) {
			getProjectStats(project.id).then((stats) => {
				if (stats.success) {
					setTotalControls({
						totalAmount: stats.data.totalAmount,
						totalApprovedAmount: stats.data.totalApprovedAmount,
					});
				}
			});
		}
	}, [project.id, summaryWheelsValues]);

	useEffect(() => {
		setRows(targets);
		totalPerColumn();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [targets]);
	useEffect(() => {
		setEconomicsInternalRows(internalExpenseItems);
		// totalPerColumn();
	}, [internalExpenseItems]);

	// const ConditionalWrapper = ({ condition, wrapper, children }) => (condition ? wrapper(children) : children);

	const saveEconomicsFramework = async () => {
		setSbShow(<></>);
		projectAmounts._method = 'PUT';
		const projectResult = await editProject(project.id, projectAmounts);

		if (projectResult.success) {
			delete projectAmounts._method;
			handleStatusBar('success', 'Progetto modificato con successo', true);
		} else {
			handleStatusBar('error', 'Non è stato possibile aggiornare gli importi', false);
		}

		applicationEconomicFrameworkValues.forEach(async (applicationEconomicFrameworkValue) => {
			applicationEconomicFrameworkValue._method = 'PUT';
			const { createdAt, createdBy, updatedAt, updatedBy, ...restApplicationEconomicFrameworkValue } = applicationEconomicFrameworkValue;

			const result = await editApplicationEconomicFrameworkValue(project.id, restApplicationEconomicFrameworkValue);
			if (result.success) {
				handleStatusBar('success', 'Importi modificati con successo', true);
			}
		});

		//per aggiornare i valori di applicationEconomicFrameworkValue appena salvati
		setTimeout(() => {
			fetchDataProject();
		}, 1000);
	};

	const onChange = (e, id, field) => {
		let value = e.value ?? 0;

		const tempApplicationEconomicFrameworkValues = [...applicationEconomicFrameworkValues];
		const index = tempApplicationEconomicFrameworkValues.findIndex((el) => el.id === id);

		value = field === 'intensity' && value > 100 ? 100 : value;

		tempApplicationEconomicFrameworkValues[index][field] = value;

		if (field === 'approvedAmount' || field === 'intensity') {
			tempApplicationEconomicFrameworkValues[index].requiredAmount =
				(tempApplicationEconomicFrameworkValues[index].approvedAmount * tempApplicationEconomicFrameworkValues[index].intensity) / 100;
		}

		setApplicationEconomicFrameworkValues(tempApplicationEconomicFrameworkValues);

		totalPerColumn();
	};

	const handleSave = async () => {
		setSbShow(<></>);
		/* projectAmounts._method = 'PUT';
		  const projectResult = await editProject(project.id, projectAmounts);
    
		  if (projectResult.success) {
			 delete projectAmounts._method;
			 handleStatusBar('success', 'Informazioni modificate con successo', true);
		  } else {
			 handleStatusBar('error', 'Non è stato possibile aggiornare gli importi', false);
		  } */

		if (!rows.every((el) => el.name && el.uom)) {
			handleStatusBar('error', `Nome e unità di misura sono obbligatori`, false);
			return;
		}

		let resultOfActions = [true];
		let resultOfMessages = [];

		let targetsCleaned = rows.filter((target) => target.name && target.uom);

		let [targetsResult] = await Promise.all([
			handleItemList('targets', originTargets, targetsCleaned, deleteProjectTarget, editProjectTarget, createProjectTarget),
		]);

		const resultOfAll = resultOfActions.concat(targetsResult ? targetsResult.resultOfActionsTemp : []);
		const resultOfAllMessages = resultOfMessages.concat(targetsResult ? targetsResult.messageResult : []);

		if (resultOfAll.length === 0 || (resultOfAll.length > 0 && resultOfAll.every((el) => el === true))) {
			setTimeout(() => {
				getAllProjectTarget(project.id).then((targets) => {
					const tempTargets = targets.data.map((target) => ({
						id: target.id,
						name: target.name,
						description: target.description,
						uom: target.uom,
						projectId: target.projectId,
						noticeTargetId: target.noticeTargetId,
						targetValue: target.targetValue,
						targetDate: target.targetDate,
					}));

					setTargets(tempTargets);
					setOriginTargets(tempTargets);
				});
			}, 500);

			handleStatusBar('success', 'Target modificati con successo', true);
		} else {
			handleStatusBar(
				'error',
				resultOfAllMessages.length > 0
					? Object.values(resultOfAllMessages[0].data).join()
					: translate('common.error.save', 'Si è verificato un errore durante il salvataggio delle informazioni'),
				false,
			);
		}

		/* rows.forEach(async (target) => {
			 if (target.isNew) {
				delete target.isNew;
				const createResult = await createProjectTarget(project.id, target);
				if (createResult.success) {
				   handleStatusBar('success', `Target ${target.name} aggiunto con successo`, true);
				} else {
				   console.log('createResult', Object.values(createResult.data));
				   handleStatusBar('error', `Non è stato possibile aggiungere il target ${target.name}`, false);
				}
			 } else {
				target._method = 'PUT';
				//delete target.targetDate; //???
    
				const editResult = await editProjectTarget(project.id, target);
				delete target._method;
				if (editResult.success) {
				   handleStatusBar('success', `Target ${target.name} modificato con successo`, true);
				} else {
				   handleStatusBar('error', `Non è stato possibile modificare il target ${target.name}`, false);
				}
			 }
		  }); */
	};

	const handleItemList = async (entityType, originItemList, itemList, deleteAPI, editAPI, createAPI) => {
		let resultOfActionsTemp = [];

		const oldItemsDeleted = originItemList.filter((object1) => {
			return !itemList.some((object2) => {
				return object1.id === object2.id;
			});
		});

		if (oldItemsDeleted.length > 0) {
			oldItemsDeleted.forEach(async (item) => {
				const deleteResult = await deleteAPI(project.id, item.id);
				resultOfActionsTemp.push(deleteResult.success);
			});
		}

		let validationFields = [];

		switch (entityType) {
			case 'targets':
				validationFields = ['name', 'uom'];
				break;
			case 'internalExp':
				validationFields = ['name'];
				break;
			default:
				validationFields = [];
		}

		let messageResult;

		for (const item of itemList) {
			const isValid = validationFields.every((field) => item[field] || (Array.isArray(item[field]) && item[field].every((el) => el)));

			if (!isValid) {
				messageResult = {
					success: false,
					data: {
						validation: [`${entityType} ${translate('common.error.notsaved', 'non salvati')}`],
					},
				};
				resultOfActionsTemp.push(false);
				continue;
			}

			if (!item.isNew) {
				const { createdAt, createdBy, updatedAt, updatedBy, ...restItem } = item;
				const result = await editAPI(project.id, restItem);
				if (!result.success) messageResult = result;
				resultOfActionsTemp.push(result.success);
			} else {
				const { isNew, ...restNewItem } = item;
				const result = await createAPI(project.id, restNewItem);
				if (!result.success) messageResult = result;
				resultOfActionsTemp.push(result.success);
			}
		}

		// let result;
		// let messageResult;

		// itemList.forEach(async (item) => {
		// 	if (validationFields.every((field) => item[field] || (Array.isArray(item[field]) && item[field].every((el) => el)))) {
		// 		if (!item.isNew) {
		// 			const { createdAt, createdBy, updatedAt, updatedBy, ...restItem } = item;
		// 			result = await editAPI(project.id, restItem);
		// 			//console.log('result:', result);
		// 			if (result.success === false) messageResult = result;
		// 			resultOfActionsTemp.push(result.success);
		// 		} else {
		// 			const { isNew, ...restNewItem } = item;
		// 			result = await createAPI(project.id, restNewItem);
		// 			//console.log('result:', result);
		// 			if (result.success === false) messageResult = result;
		// 			resultOfActionsTemp.push(result.success);
		// 		}
		// 	} else {
		// 		//console.log('non riempiti');
		// 		messageResult = {
		// 			success: false,
		// 			data: {
		// 				validation: [`${entityType} ${translate('common.error.notsaved', 'non salvati')}`],
		// 			},
		// 		};
		// 		resultOfActionsTemp.push(false);
		// 		return;
		// 	}
		// });

		//console.log('messageResult', messageResult);
		return { resultOfActionsTemp, messageResult };
	};

	const totalPerColumn = () => {
		const total = applicationEconomicFrameworkValues.reduce(
			(acc, { amount, admissibleAmount, approvedAmount, requiredAmount }) => {
				return {
					projectAmount: acc.projectAmount + amount,
					admissibleAmount: acc.admissibleAmount + admissibleAmount,
					approvedAmount: acc.approvedAmount + approvedAmount,
					requiredAmount: acc.requiredAmount + requiredAmount,
				};
			},
			{
				projectAmount: 0,
				admissibleAmount: 0,
				approvedAmount: 0,
				requiredAmount: 0,
			},
		);

		setTotalAmounts(total);
		setProjectAmounts({
			...projectAmounts,
			totalApprovedAmount: total.requiredAmount ?? 0,
		});
	};

	const targetRow = () => {
		let tempTargets = [...rows];

		if (tempTargets.length === 0) {
			tempTargets = [
				{
					name: '',
					uom: '',
					projectId: project.id,
					targetValue: 0,
					//targetDate: null,
					isNew: true,
				},
			];
		}

		const addRow = (id) => {
			if (!isModified) setIsModified(true);
			let tempTypeArray = [...tempTargets];

			tempTypeArray.push({
				name: '',
				uom: '',
				projectId: project.id,
				targetValue: 0,
				//targetDate: null,
				isNew: true,
			});

			setRows(tempTypeArray);
		};

		const removeRow = async (target, index) => {
			if (!isModified) setIsModified(true);
			let tempTypeArray = [...tempTargets];

			tempTypeArray.splice(index, 1);

			setRows(tempTypeArray);
		};

		const handleInputChange = (id, inputName, value, elIndex) => {
			//row.id, 'targetDate', e.target.value
			if (!isModified) setIsModified(true);
			let tempList = [...tempTargets];

			value = inputName === 'targetDate' && value ? dateFormatterInput(value) : value;

			let tempElement = {
				...tempList[elIndex],
				[inputName]: value,
				//projectId: thisProject.id,
			};

			tempList[elIndex] = tempElement;

			setRows(tempList);
		};

		let lastIndex = tempTargets.length - 1;

		return (
			<div>
				<table className="show-targets-tab">
					<thead>
						<tr>
							<th>Target</th>
							<th className="f-600 text-center">Data</th>
							<th className="f-600">Unità di misura</th>
							<th className="f-600 text-end">Valore</th>
							<th className="invisible">
								<Button variant="link" onClick={() => null} disabled={true}>
									<IcoPlus className="second-color ico-small indicators" />
								</Button>
								<Button disabled={true} variant="link" onClick={() => null}>
									<IcoMinusCircled className="red-color ico-small indicators" />
								</Button>
							</th>
						</tr>
					</thead>
					<tbody>
						{tempTargets.map((row, i) => {
							const isThisRowFilled = row.name && row.uom ? true : false;
							return (
								<tr key={'target' + i}>
									<td className="f-600">
										{(isOe || userAccess.isAboveIncludingProjectManager) && !row.noticeTargetId ? (
											<Form.Control
												type="text"
												value={row.name}
												placeholder={'target*'}
												onChange={(e) => handleInputChange(row.id, 'name', e.target.value, i)}
											/>
										) : (
											<div className="f-600">{row?.name ?? 'N.D.'}</div>
										)}
									</td>
									<td>
										{isOe || userAccess.isAboveIncludingProjectManager ? (
											<Form.Control
												className="text-center"
												type="date"
												name="targetDate"
												value={row.targetDate ? moment(row.targetDate).format('YYYY-MM-DD') : ''}
												onChange={(e) => handleInputChange(row.id, 'targetDate', e.target.value, i)}
											/>
										) : (
											<span className="mt-3">{row.targetDate ? dateFormatter(row.targetDate) : 'N.D'}</span>
										)}
									</td>
									<td>
										{(isOe || userAccess.isAboveIncludingProjectManager) && !row.noticeTargetId ? (
											<Form.Control
												type="text"
												value={row.uom}
												placeholder="udm*"
												onChange={(e) => handleInputChange(row.id, 'uom', e.target.value, i)}
											/>
										) : (
											<div className="">{row?.uom ?? 'N.D.'}</div>
										)}
									</td>
									<td className={isOe || userAccess.isAboveIncludingProjectManager ? '' : 'text-end'}>
										{isOe || userAccess.isAboveIncludingProjectManager ? (
											<InputNumber
												min={0}
												minFractionDigits={0}
												maxFractionDigits={2}
												onChange={(e) => handleInputChange(row.id, 'targetValue', e.value, i)}
												mode="decimal"
												locale={localLang}
												className="md"
												value={row.targetValue}
											/>
										) : (
											<span>
												{formatToDecimals(
													row.targetValue,
													row.uom.toLowerCase() === 'abitanti' ? 0 : 2,
													row.uom.toLowerCase() === 'abitanti' ? 0 : 2,
												)}
											</span>
										)}
									</td>

									<td className="text-nowrap">
										{i === lastIndex && (isOe || userAccess.isAboveIncludingProjectManager) ? (
											<Button
												variant="link"
												className="me-3"
												style={{ width: '25px', height: '25px' }}
												onClick={() => addRow(tempTargets[tempTargets.length - 1].id + 1)}
												disabled={!isThisRowFilled}
											>
												<IcoPlus className="second-color ico-small indicators" />
											</Button>
										) : null}
										{(isOe || userAccess.isAboveIncludingProjectManager) &&
										(isProjectWp || (!isProjectWp && tempTargets.length !== 1 && !row.noticeTargetId)) ? (
											<Button
												style={{ width: '25px', height: '25px' }}
												disabled={!isProjectWp && !isOe}
												variant="link"
												onClick={() => removeRow(row, i)}
											>
												<IcoMinusCircled className="red-color ico-small indicators" />
											</Button>
										) : null}
									</td>
								</tr>
							);
						})}
					</tbody>
				</table>

				{(isOe || userAccess.isAboveIncludingProjectManager) && (
					<Row className="mt-5 mb-2 text-center">
						<Col>
							<Button onClick={handleSave} disabled={!isModified}>
								<OETrans code="common.save" fallback={'Salva'} />
							</Button>
						</Col>
					</Row>
				)}
			</div>
		);
	};

	// const onChangeInternal = (value, fieldName, setSelect, elIndex, list) => {
	// 	let tempList = [...list];

	// 	let tempElement = {
	// 		...tempList[elIndex],
	// 		[fieldName]: value,
	// 	};

	// 	tempList[elIndex] = tempElement;

	// 	//console.log('tempList', tempList);

	// 	setSelect(tempList); //as setList
	// };

	// const addElement = (typeArray, setTypeArray) => {
	// 	let tempTypeArray = [...typeArray];

	// 	tempTypeArray.push({
	// 		name: '',
	// 		amount: 0,
	// 		admissibleAmount: 0,
	// 		approvedAmount: 0,
	// 		isNew: true,
	// 	});

	// 	setTypeArray(tempTypeArray);
	// };
	// const removeElement = (typeArray, setTypeArray, index) => {
	// 	let tempTypeArray = [...typeArray];

	// 	tempTypeArray.splice(index, 1);

	// 	setTypeArray(tempTypeArray);
	// };
	// const economicInternalRows = (internalExpItems, setInternalExpItems) => {
	// 	let rows = [];

	// 	if (internalExpItems) {
	// 		if (internalExpItems.length === 0) {
	// 			internalExpItems = [
	// 				{
	// 					name: '',
	// 					amount: 0,
	// 					admissibleAmount: 0,
	// 					approvedAmount: 0,
	// 					position: null,
	// 					isNew: true,
	// 				},
	// 			];
	// 		}

	// 		let lastIndex = internalExpItems.length - 1;

	// 		rows = internalExpItems
	// 			.sort((a, b) => {
	// 				return a.position - b.position;
	// 			})
	// 			.map((el, i) => {
	// 				const isThisRowFilled = el.name ? true : false;

	// 				return (
	// 					<Row key={'cig-' + i} className="d-flex align-items-center mb-3">
	// 						{isOe || userAccess.isAboveIncludingProjectManager ? (
	// 							<>
	// 								<Col className="col-4">
	// 									<Form.Control
	// 										type="text"
	// 										value={el.name ?? ''}
	// 										onChange={(e) => onChangeInternal(e.target.value, 'name', setInternalExpItems, i, internalExpItems)}
	// 										placeholder="Voce di spesa"
	// 										disabled={(!isProjectWp && !isOe) || (isProjectWp && !userAccess.isAboveIncludingProjectManager)}
	// 									/>
	// 								</Col>
	// 								<Col className="col-3">
	// 									<InputNumber
	// 										min={0}
	// 										minFractionDigits={2}
	// 										maxFractionDigits={2}
	// 										onChange={(e) => onChangeInternal(e.value, 'amount', setInternalExpItems, i, internalExpItems)}
	// 										mode="decimal"
	// 										locale={localLang}
	// 										className="md"
	// 										value={el.amount}
	// 										disabled={(!isProjectWp && !isOe) || (isProjectWp && !userAccess.isAboveIncludingProjectManager)}
	// 									/>
	// 								</Col>
	// 								<Col className="col-1 pe-0">
	// 									{i === lastIndex && (isOe || userAccess.isAboveIncludingProjectManager) ? (
	// 										<Button
	// 											variant="link"
	// 											className="me-3"
	// 											onClick={() => addElement(internalExpItems, setInternalExpItems)}
	// 											disabled={!isThisRowFilled}
	// 										>
	// 											<IcoPlus className="second-color ico-small indicators" />
	// 										</Button>
	// 									) : null}
	// 									{(isOe || userAccess.isAboveIncludingProjectManager) && (
	// 										<Button variant="link" onClick={() => removeElement(internalExpItems, setInternalExpItems, i)}>
	// 											<IcoMinusCircled className="red-color ico-small indicators" />
	// 										</Button>
	// 									)}
	// 								</Col>
	// 							</>
	// 						) : (
	// 							<>
	// 								<Col className="col-4 ps3-3">
	// 									<p className="f-600">{el.name}</p>
	// 								</Col>
	// 								<Col className="col-3 text-end">
	// 									<span className="">{formatToDecimals(el.amount)}</span>
	// 								</Col>
	// 								<Col className="col-1"></Col>
	// 							</>
	// 						)}
	// 					</Row>
	// 				);
	// 			});
	// 	}

	// 	return rows;
	// };

	// const handleSaveEconomicsInternal = async (e) => {
	// 	e?.preventDefault();

	// 	setSbShow(<></>);

	// 	const set = new Set();

	// 	const isNotNameUnique = internalExpenseItems.some((object) => set.size === (set.add(object.name), set.size));

	// 	if (isNotNameUnique) {
	// 		// handleStatusBar('error', 'I codici CIG non possono essere uguali', false);
	// 		handleStatusBar('error', 'I nomi degli expense items non possono essere uguali', true);
	// 		return;
	// 	}

	// 	let finalInternalExpenseItems = internalExpenseItems.map((el, i) => ({
	// 		...el,
	// 		position: i,
	// 	}));

	// 	let resultOfActions = [true];
	// 	let resultOfMessages = [];

	// 	let [internalExpenseItemsResults] = await Promise.all([
	// 		handleItemList(
	// 			'internalExp',
	// 			originInternalExpenseItems,
	// 			finalInternalExpenseItems,
	// 			deleteProjectInternalExpenseItems,
	// 			editProjectInternalExpenseItems,
	// 			createProjectInternalExpenseItems,
	// 		),
	// 	]);

	// 	const resultOfAll = resultOfActions.concat(internalExpenseItemsResults ? internalExpenseItemsResults.resultOfActionsTemp : []);
	// 	const resultOfAllMessages = resultOfMessages.concat(internalExpenseItemsResults ? internalExpenseItemsResults.messageResult : []);

	// 	if (resultOfAll.length === 0 || (resultOfAll.length > 0 && resultOfAll.every((el) => el === true))) {
	// 		setTimeout(() => {
	// 			getAllProjectInternalExpenseItems(project.id).then((internalExpenseItems) => {
	// 				// const tempTargets = targets.data.map((target) => ({
	// 				//   id: target.id,
	// 				//   name: target.name,
	// 				//   description: target.description,
	// 				//   uom: target.uom,
	// 				//   projectId: target.projectId,
	// 				//   noticeTargetId: target.noticeTargetId,
	// 				//   targetValue: target.targetValue,
	// 				//   targetDate: target.targetDate,
	// 				// }));

	// 				setInternalExpenseItems(internalExpenseItems.data);
	// 				setOriginInternalExpenseItems(internalExpenseItems.data);
	// 			});
	// 		}, 1500);

	// 		handleStatusBar('success', 'Operazione eseguita con successo', true);
	// 	} else {
	// 		handleStatusBar(
	// 			'error',
	// 			resultOfAllMessages.length > 0
	// 				? Object.values(resultOfAllMessages[0].data).join()
	// 				: translate('common.error.save', 'Si è verificato un errore durante il salvataggio delle informazioni'),
	// 			false,
	// 		);
	// 	}
	// };

	const tabNavItems = [
		{
			eventKey: 'economics',
			title: 'Quadro Economico',
			transCode: 'common.candidacy.economicframework',
			content:
				project?.streamConfigurationType === 'STREAM' ? (
					<EconomicFrameworkStream
						projectId={project.id}
						isOe={isOe}
						isExternalAdmin={userAccess.isExternalAdmin}
						applicationEconomicFrameworkValues={applicationEconomicFrameworkValues}
						totalAmounts={totalAmounts}
						totalControls={totalControls}
						onChange={onChange}
						saveEconomicsFramework={saveEconomicsFramework}
						localLang={localLang}
					/>
				) : project?.streamConfigurationType === 'WP' ? (
					<>
						<Row className="align-items-center mb-3 pe-0">
							<Col xs="auto">
								<DownloadExcelButton
									apiDownload={downloadEconomicFramework}
									apiProps={[project?.id]}
									label={translate('common.downloadexcel', 'Scarica excel')}
								/>
							</Col>
						</Row>
						<EconomicFrameworkWp
							projectId={project?.id}
							isOe={isOe}
							isExternalAdmin={userAccess.isExternalAdmin}
							isAboveGuest={userAccess.isAboveGuest}
							applicationEconomicFrameworkValues={applicationEconomicFrameworkValues}
							setApplicationEconomicFrameworkValues={setApplicationEconomicFrameworkValues}
							isThereWp={project?.streams?.length > 0}
							localLang={localLang}
							myUserCompanies={companies}
						/>
					</>
				) : null,
		},
		{
			eventKey: 'target',
			title: 'Target',
			transCode: 'common.candidacy.target',
			shouldBeVisible: isProjectWp ? userAccess.isAboveIncludingProjectManager : !isBeneficiary && userAccess.isGuest,
			content: targetRow(),
		},
	];

	return (
		<>
			<NavTabs tabNavItems={tabNavItems} />
			{sbShow}
			{/*  <div className='simple-box scenaritab'>
            <div className='row d-flex align-items-center mb-3'>
               <div className='col-4'>
                  <h5 className='title-simple-box'>Documenti utili</h5>
               </div>
            </div>

            <Row className='mb-3 mt-5'>
               <Col className='col-6 border-tab right text-start py-3'>
                  <Form.Group as={Col} className='mb-4 px-3' >
                     <Form.Label className='mb-3 me-1'>
                        Progetto Candidato
                        <span className='required-field'>*</span>
                     </Form.Label>
                     <div className='me-4 d-block'>
                        <Button variant='link'>
                           <IcoUploadFile role='button' className='second-color ico-small download-upload align-bottom' />
                        </Button>
                     </div>
                  </Form.Group>

                  <Form.Group as={Col} className='mb-4 px-3' >
                     <Form.Label className='mb-3 me-1'>
                        Allegati candidatura
                        <span className='required-field'>*</span>
                     </Form.Label>
                     <div className='me-4 d-block'>
                        <Button variant='link'>
                           <IcoUploadFile role='button' className='second-color ico-small download-upload align-bottom' />
                        </Button>
                     </div>
                  </Form.Group>

                  <Form.Group as={Col} className='mb-4 px-3' >
                     <Form.Label className='mb-3 me-1'>
                        Graduatoria
                        <span className='required-field'>*</span>
                     </Form.Label>
                     <div className='me-4 d-block'>
                        <Button variant='link'>
                           <IcoUploadFile role='button' className='second-color ico-small download-upload align-bottom' />
                        </Button>
                     </div>
                  </Form.Group>

                  <Form.Group as={Col} className='mb-4 px-3' >
                     <Form.Label className='mb-3 me-1'>
                        Decreto di concessione
                        <span className='required-field'>*</span>
                     </Form.Label>
                     <div className='me-4 d-block'>
                        <Button variant='link'>
                           <IcoUploadFile role='button' className='second-color ico-small download-upload align-bottom' />
                        </Button>
                     </div>
                  </Form.Group>

                  <Row className="mt-5 px-3 ">
                     <Form.Group as={Col} className='' >
                        <Form.Label className='mb-3 me-1'>
                           Altri documenti
                        </Form.Label>
                        <Row className='me-4 align-items-center'>
                           <Select
                              as={Col}
                              className='col-10'
                              name="docs"
                              placeholder="Seleziona tipo documento..."
                              value={[]}
                              options={[]}
                              onChange={(e) => onChange(e)}
                           />
                           <Button as={Col} variant='link' className="col-2 ps-3 mt-1 text-start">
                              <IcoUploadFile role='button' className='second-color ico-small download-upload align-bottom' />
                           </Button>
                        </Row>
                     </Form.Group>
                  </Row>
               </Col>

               <Col className='col-6 py-3 text-center text-muted'>
                  viewer documenti
               </Col>
            </Row>
         </div> */}

			{/*   <Button
            variant="secondary"
            className="save-button"
            type="submit"
            form="candidacy-form"
            onClick={handleSave}
         >
            SALVA
         </Button> */}
		</>
	);
};
export default Candidacy;
